<template>
  <a-modal
    width="800px"
    :title="title"
    :visible="visible"
    @ok="ok"
    @cancel="cancel"
  >
  <!-- :scroll="{y: 300}" -->
    <a-table
      bordered
      :pagination="pagination"
      :columns="columns"
      :data-source="list"
      :scroll="{x: 300}"
    />
    <template slot="footer">
      <a-button type="primary" @click="ok">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import { mapState,mapMutations } from 'vuex';
import api from '../../api'
import moment from 'moment';
export default {
  components: {},
  props: ['dateRange'],
  data() {
    return {
      list: [],
      monthLst: [],
      pagination: {
        total:0,
        pageSize:20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `总共${total}个记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
    }
  },
  watch: {
    sortDetailVisible(val){
      if(val) this.getList({current: 1,pageSize: 20})
    },
  },
  computed: {
    ...mapState('empirical',['sortRow','sortDetailVisible']),
    visible:{
      set(){},
      get(){return this.sortDetailVisible}
    },
    title(){
      return this.sortRow.settlementName || '测试详情名称'
    },
    columns(){
      let monthLst = this.sortMonth(this.monthLst)
      let children = monthLst.map(title => {
        return {
          title,
          dataIndex: `${title}Val`,
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        }
      })
      let lst = [
        {
          title: '营养师',
          dataIndex: 'createUserName',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'tips' },
        },
        {
          title: '填报总数',
          dataIndex: 'num',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'tips' },
        },
        {
          title: '月度/年度条报总数',
          // dataIndex: 'cost',
          children
        },
      ]
      return [...lst]
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapMutations('empirical',['setState']),
    sortMonth(arr){
      let lst = arr.sort((a,b) => {
        let aArr = a.split('.')
        let bArr = b.split('.')
        let x = new Date(`${aArr[0]}-${aArr[1]}`).getTime()
        let y = new Date(`${bArr[0]}-${bArr[1]}`).getTime()
        return x - y
      })
      return lst
    },
    ok(){
      this.setState({sortDetailVisible: false})
    },
    cancel(){
      this.setState({sortDetailVisible: false})
    },
    async getList(pagination){
      let time = this.dateRange
      let {current,pageSize: size = 20} = pagination || this.pagination
      let params = {
        current,size,settlementId: this.sortRow.settlementId,
        startTime: time && time.length > 0 ? moment(time[0]).format('YYYY-MM-DD 00:00:00') : undefined,
        endTime: time && time.length > 0 ? moment(time[1]).format('YYYY-MM-DD 23:59:59') : undefined,
      }
      let res = await api.settlementDetail(params)
      let {success,data} = res || {}
      if(success){
        let {records,current=1,total=0,size=20} = data;
        this.pagination.current = current
        this.pagination.pageSize = size
        this.pagination.total = total
        // this.list = data.records || []
        let monthLst = []
        let lst = records.map(el => {
          el.dateDetailList && el.dateDetailList.forEach(item => {
            el[`${item.date}Val`] = item.num
            if(!monthLst.includes(item.date)) {
              monthLst.push(item.date)
            }
          })
          return el
        })
        this.monthLst = monthLst
        this.list = lst
      }
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>